var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "column flex-1 p-2" }, [
    _c(
      "div",
      {
        staticClass:
          "summary-card bg-white invoice-shadow rounded-md md py-4 px-7 flex items-center h-full",
      },
      [
        _c(
          "div",
          { class: [_vm.defaultInitialsClasses] },
          [_c(_vm.icon, { tag: "component" })],
          1
        ),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "description text-sm text-gray-600 mb-1" }, [
            _vm._v(" " + _vm._s(_vm.description) + " "),
          ]),
          _c("div", { staticClass: "amount text-xl font-bold" }, [
            _vm._v(_vm._s(_vm.amount)),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }